export default __webpack_public_path__ + "static/media/cloud-1-night.f5e650b6.svg";